export default "__VITE_ASSET__BRWoYKrv__"